const contact = {
  contact: {
    hero: {
      title: 'تواصل مع صفقات 24',
      subtitle: 'فريقنا جاهز لمساعدتك في جميع استفساراتك العقارية.',
    },
    intro: {
      title: 'اختر أسلوب التواصل الذي يناسبك',
      description: 'نحن هنا لمساعدتك. تواصل معنا عبر الهاتف أو البريد الإلكتروني.',
    },
    channels: {
      title: 'تواصل معنا',
      description: 'اختر الطريقة المناسبة لك وسنكون سعداء بخدمتك.',
      items: [
        {
          icon: 'ri-phone-line',
          title: 'اتصل بنا أو واتساب',
          subtitle: '+966 50 560 8271',
          details: [
            'متوفرون يومياً من 9:00 صباحاً حتى 6:00 مساءً',
            'استفسارات عن العقارات المتاحة',
            'مساعدة في البحث عن العقار المناسب',
            'دعم فني للمنصة',
          ],
        },
        {
          icon: 'ri-mail-line',
          title: 'البريد الإلكتروني',
          subtitle: 'info@safaqat24.sa',
          details: [
            'نرد خلال 1 إلى 5 أيام عمل',
            'إرسال استفسارات تفصيلية',
            'طلبات الشراكة والتعاون',
            'الدعم الفني والمساعدة',
          ],
        },
      ],
    },
    newsletter: {
      title: 'ابق على اطلاع بآخر العقارات',
      subtitle: 'اشترك ليصلك أحدث العروض العقارية والتحديثات.',
      interestLabel: 'الموضوعات المفضلة',
      interestHelper: 'اختر كل ما ينطبق عليك',
      interests: [
        'فلل للبيع',
        'شقق للإيجار',
        'عقارات تجارية',
        'أراضي للبيع',
        'تحديثات السوق',
        'عروض جديدة',
      ],
      fields: {
        emailLabel: 'البريد الإلكتروني *',
        emailPlaceholder: 'you@company.com',
        firstNameLabel: 'الاسم الأول',
        firstNamePlaceholder: 'محمد',
      },
      submitLabel: 'اشترك الآن',
      submitting: 'يتم الاشتراك...',
      success: 'تم الاشتراك بنجاح! ستصلك تحديثاتنا قريباً.',
      error: 'تعذر إكمال الاشتراك. يرجى المحاولة مرة أخرى.',
    },
    form: {
      title: 'أرسل لنا رسالة',
      subtitle: 'شاركنا التفاصيل وسنتواصل معك في أقرب وقت.',
      replyTime: 'سنتواصل معك خلال 1 إلى 5 أيام عمل.',
      success: 'شكراً لك! تم استلام رسالتك وسيتم التواصل معك قريباً.',
      error: 'تعذر إرسال الرسالة. يرجى إعادة المحاولة.',
      fields: {
        nameLabel: 'الاسم الكامل *',
        namePlaceholder: 'محمد العلي',
        emailLabel: 'البريد الإلكتروني *',
        emailPlaceholder: 'you@company.com',
        phoneLabel: 'رقم الهاتف',
        phonePlaceholder: '+966 55 123 4567',
        subjectLabel: 'سبب التواصل *',
        subjectOptions: [
          { value: '', label: 'اختر موضوعاً' },
          { value: 'property-inquiry', label: 'استفسار عن عقار' },
          { value: 'general-question', label: 'سؤال عام' },
          { value: 'technical-support', label: 'دعم فني' },
          { value: 'partnership', label: 'فرصة شراكة' },
          { value: 'other', label: 'أخرى' },
        ],
        messageLabel: 'كيف يمكننا مساعدتك؟ *',
        messagePlaceholder: 'اكتب رسالتك هنا...',
        messageCounter: '{{count}}/500 حرف',
      },
      submitLabel: 'إرسال الرسالة',
      submitting: 'يتم الإرسال...',
    },
    consultation: {
      title: 'هل تحتاج مساعدة في البحث عن عقار؟',
      description: 'دعنا نساعدك في العثور على العقار المناسب لاحتياجاتك.',
      button: 'ابدأ البحث',
    },
    alerts: {
      contactSuccess: 'شكراً لك! تم إرسال رسالتك بنجاح. سنتواصل معك خلال 1 إلى 5 أيام عمل.',
      contactError: 'حدث خطأ أثناء إرسال الرسالة. حاول مرة أخرى.',
      newsletterSuccess: 'تم اشتراكك بنجاح.',
      newsletterError: 'تعذر إتمام الاشتراك. حاول مرة أخرى لاحقاً.',
    },
  },
};

export default contact;
